import moment from 'moment';

import { setError, setSuccessMessage } from '../../modules/App/ErrorsActions';
import * as BECaller from '../../util/apiCaller';
import downloadFile from '../../util/download';
import { getInfo } from '../Auth/AuthActions';

export const LOADING = 'REPORT_SETTING_LOADING';
export const SUCCESS_STREAMS = 'VALUE_STREAMS_SUCCESS';
export const SUCCESS_FILTERS = 'REPORT_SUCCESS_FILTERS';
export const SUCCESS_DATA = 'REPORT_SUCCESS_DATA';
export const SUCCESS_COMPARISON_DATA = 'REPORT_SUCCESS_COMPARISON_DATA';
export const UPDATE_DATES = 'REPORT_UPDATE_DATES';
export const UPDATE_DATE_RANGE= 'REPORT_UPDATE_DATE_RANGE';
export const SELECT_STREAM = 'STREAMS_SELECT';
export const UPDATE_SELECTED_STREAM = 'STREAMS_UPDATE_SELECTED';
export const NO_STREAMS = 'NO_STREAMS';

const MAX_RETRIES = 3600;

export function handleError(err, opt) {
  return setError(err, opt);
}

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool,
  };
}

export function successStreams(data) {
  return {
    type: SUCCESS_STREAMS,
    streams: data,
  };
}

export function noStreams() {
  return {
    type: NO_STREAMS
  };
} 

export function successFilters(data) {
  return {
    type: SUCCESS_FILTERS,
    filters: data,
  };
}

function successData(data) {
  return {
    type: SUCCESS_DATA,
    data,
  };
}


function successComparisonData(data) {
  return {
    type: SUCCESS_COMPARISON_DATA,
    data,
  };
}

export function selectStream(stream, viewId) {
  return {
    type: SELECT_STREAM,
    selected: stream,
    viewId
  };
}

export function updateSelectedStream(stream) {
  return {
    type: UPDATE_SELECTED_STREAM,
    selected: stream
  };
}

export function deleteStream(streamId){
  return dispatch => {
      BECaller.api(`executive/values/${streamId}`, 'delete').then(
        () => {
          dispatch(listAll());
        },
        err => {
          dispatch(handleError(err));
        }
      );
    };
}

export function saveSelected(id) {
  return dispatch => {
    BECaller.api(`executive/values/selected`, 'put', {
      id
    }).then(
      () => {},
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function saveSelectedBreakdown(id, chart, value) {
  return (dispatch, getState) => {
    BECaller.api(`executive/values/${id}/chart`, 'put', {
      chart,
      value
    }).then(
      (res) => {
        const streams = getState().report.streams;
        const updatedStreams = streams.map(stream => {
          if (stream._id === res._id) {
            return { ...stream, [chart]: res[chart] };
          }
          return stream;
        });
        dispatch(successStreams(updatedStreams));

        const selectedStream = getState().report.selectedStream;
        if (selectedStream && selectedStream._id === res._id) {
          dispatch(updateSelectedStream({ ...selectedStream, [chart]: res[chart] }));
        }
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function saveSelectedDateRange(id, dateRange) {
  return dispatch => {
    BECaller.api(`executive/values/${id}/dateRange`, 'put', {
      dateRange
    }).then(
      (data) => {
        dispatch(setDateRange(data));
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function listAll() {
  return (dispatch, getState) => {
    dispatch(isLoading(true));
    return BECaller.api(`executive/values/list`, 'get').then(
      (data) => {
         if (data.length) {
            let selected = getState().report.selectedStream;
            if (selected && selected._id) {
                let selectedStream = _.find(data, b => b._id == selected._id);
                selectedStream && dispatch(selectStream({ ...selectedStream }));
             }          
             dispatch(successStreams(_.sortBy(data, 'name')));
             return data;
          } else {
              dispatch(noStreams());
              return [];
           }                 
      },
      (err) => {
        dispatch(handleError(err));
        throw err;
      }
    );
  };
}

export function saveStream(data) {
  return (dispatch, getState) => {
    dispatch(isLoading(true));
    return BECaller.api(`executive/settings`, 'post', data).then(
      (res) => {
        dispatch(isLoading(false));
        dispatch(setSuccessMessage('Settings updated successfully'));
        dispatch(selectStream({ ...res }));
        
        let streams = getState().report.streams;
        const index = streams.findIndex(s => s._id === res._id);
        
        if (index !== -1) {
          streams[index] = res;
        } else {
          streams.push(res);
        }
        
        dispatch(successStreams(_.sortBy(streams, 'name')));
        return res;
      },
      (err) => {
        dispatch(handleError(err));
        dispatch(isLoading(false));
        throw err;
      }
    );
  };
}

export function getFilters(id) {  
    const url = `executive/filters/${id}`;
    return (dispatch) => {
      if (!id) return;
      BECaller.api(url, 'get').then(
        (data) => {
          dispatch(setDates(data));
          dispatch(setDateRange(data));
          dispatch(successFilters(data));
        },
        (err) => {
          dispatch(isLoading(false));
        }
      );
    };   
}

export function setFilters(id, data, returnData = false) {
  return (dispatch) => {
    dispatch(isLoading(true));
    const url = 'executive/filters' + (id ? `/${id}` : '');
    const body = returnData ? { ...data, returnData: true } : data;
    return BECaller.api(url, 'post', body).then(
      (response) => {
        if (response.stats) {
          dispatch(setDates(response));
          dispatch(setDateRange(response));
          dispatch(successFilters(response));
          dispatch(successData(response));
          return { hasData: true, data: response };
        }
        dispatch(setDates(response));
        dispatch(setDateRange(response));
        dispatch(successFilters(response));
        dispatch(isLoading(false));
        return { hasData: false, data: response };
      },
      (err) => {
        dispatch(handleError(err));
        dispatch(isLoading(false));
        return { hasData: false, error: err };
      }
    );
  };
}

export function requestData(id) {  
  const url = `executive/data/${id}`;
  let retries = 0,
  timeout,
  lastVal;
  return (dispatch, getState) => {
    const dates = getState().report.dates;
    if (!dates) return;
    if (!id) return;
    dispatch(isLoading(true));
    const body = {
      groupBy: 'month',
      offset: dates.startDate.utcOffset(),
      tz: !!window.Intl ? Intl.DateTimeFormat().resolvedOptions().timeZone : null,
      from: dates.startDate.toISOString(),
      to: dates.endDate.toISOString(),
    };

    BECaller.api(url, 'post', body)
      .then((res) => {
        if (res.stats){
            dispatch(successData(res));
            dispatch(isLoading(false));
            return;          
        }
        else{
          !!timeout && clearInterval(timeout);
          timeout = setInterval(poll, 1500, dispatch, res);       
        }
        
      })
      .catch((err) => {
        dispatch(handleError(err));
        dispatch(isLoading(false));
      });
      
      function poll(dispatch, jobId) {
        if (retries >= MAX_RETRIES) {
          !!timeout && clearInterval(timeout);
          dispatch(setError('Could not load data'));
          return;
        }
    
        checkPullingState(jobId)
          .then(res => {
            if (res.running && !lastVal) {
              lastVal = res.progress;              
            }
    
            if (res.noJob || res.completed || res.failed) {
              retries = 0;
              !!timeout && clearInterval(timeout);
              if (res.completed){
                dispatch(successData(res.data));
              }
              else if (res.failed){                
                dispatch(setError("Something went wrong. Please try again later or contact us"));
              }              
              dispatch(isLoading(false));
              return
            }
            retries++;
          })
          .catch(err => {
            !!timeout && clearInterval(timeout);
            dispatch(setError(err));
          });

          function checkPullingState(job) {
            return new Promise((resolve, reject) => {
              BECaller.api(`executive/data/${job.jobId}/pullingstatus/${id}`, 'get').then(
                res => {
                  resolve(res);
                },
                err => {
                  reject(err);
                }
              );
            });
          }
      }
  };
}

export function requestComparisonData(page = 1, id) {  
  const url = `comparison/data/${id}`;  
  let retries = 0,
  timeout,
  lastVal;
  return (dispatch, getState) => {
    const filters = getState().report.filters;
    const dateRange = getState().report.dateRange;    
    if (!id) return;
    dispatch(isLoading(true));
    const body = {     
      page,
      offset: moment(filters.from).utcOffset(),
      tz: !!window.Intl ? Intl.DateTimeFormat().resolvedOptions().timeZone : null,
    };

    BECaller.api(url, 'post', body)
      .then((res) => {
        if (res.comparisons){
            dispatch(successComparisonData(res));
            dispatch(isLoading(false));
            return;          
        }
        else{
          !!timeout && clearInterval(timeout);
          timeout = setInterval(poll, 1500, dispatch, res);       
        }
        
      })
      .catch((err) => {
        dispatch(handleError(err));
        dispatch(isLoading(false));
      });
      
      function poll(dispatch, jobId) {
        if (retries >= MAX_RETRIES) {
          !!timeout && clearInterval(timeout);
          dispatch(setError('Could not load data'));
          dispatch(isLoading(false));
          return;
        }
    
        checkPullingState(jobId)
          .then(res => {
            if (res.running && !lastVal) {
              lastVal = res.progress;              
            }
    
            if (res.noJob || res.completed || res.failed) {
              retries = 0;
              !!timeout && clearInterval(timeout);
              if (res.completed){
                dispatch(successComparisonData(res.data));
              }
              else if (res.failed){                
                dispatch(setError("Something went wrong. Please try again later or contact us"));
              }              
              dispatch(isLoading(false));
              return
            }
            retries++;
          })
          .catch(err => {
            !!timeout && clearInterval(timeout);
            dispatch(setError(err));
            dispatch(isLoading(false))
          });

          function checkPullingState(job) {
            return new Promise((resolve, reject) => {
              BECaller.api(`executive/data/${job.jobId}/pullingstatus/${id}`, 'get').then(
                res => {
                  resolve(res);
                },
                err => {
                  reject(err);
                }
              );
            });
          }
      }
  };
}

export function getComparisonPdf(percentile, threshold, id) {
  return (dispatch, getState) => {
    dispatch(isLoading(true));
    const dates = getState().report.dates;
    const dateRange = getState().report.dateRange;
    const url = `comparison/download/${id}`;
    const body = {
      groupBy: 'month',
      from: dates.startDate.toISOString(),
      to: dates.endDate.toISOString(),      
      dateRange,
      percentile,
      threshold,
      offset: dates.startDate.utcOffset(),
      tz: !!window.Intl ? Intl.DateTimeFormat().resolvedOptions().timeZone : null
    };

    BECaller.api(url, 'post', body)
      .then((res) => {
        downloadFile(res.url, res.filename);
        dispatch(isLoading(false));
      })
      .catch((err) => {
        dispatch(handleError(err));
        dispatch(isLoading(false));
      });
  };
}

export function getPdf(id) {
  return (dispatch, getState) => {
    const dates = getState().report.dates;
    const body = {
      offset: dates.startDate.utcOffset(),
      tz: !!window.Intl ? Intl.DateTimeFormat().resolvedOptions().timeZone : null,
      from: dates.startDate.toISOString(),
      to: dates.endDate.toISOString(),
    };

    BECaller.api(`executive/download/${id}`, 'post', body)      
      .then((res) => {
        downloadFile(res.url, res.filename);
        dispatch(isLoading(false));
      })
      .catch((err) => {
        dispatch(handleError(err));
        dispatch(isLoading(false));
      });
  };
}

export function getCsv(id) {
  return (dispatch, getState) => {
    const dates = getState().report.dates;
    const body = {
      from: moment(dates.startDate).format('YYYY-MM-DD'),
      to:moment(dates.endDate).format('YYYY-MM-DD'),
      type: 'csv'
    };

    BECaller.api(`stream/download/${id}`, 'post', body)      
      .then((res) => {
        downloadFile(res.url, res.filename, true);
        dispatch(setSuccessMessage('Exporting CSV file'));
        dispatch(isLoading(false));
      })
      .catch((err) => {
        dispatch(handleError(err));
        dispatch(isLoading(false));
      });
  };
}

export function setDateRange(model) {
  return (dispatch) => {
    let dateRange = 'lastMonth';
    try {
      dateRange = JSON.parse(model.dateRange);
      if (dateRange.value) {
        dateRange = dateRange.value;
      }
    } catch (e) {
      dateRange = model.dateRange;
    }
    dispatch(updateDateRange(dateRange));
  }
}

export function setDates(model) {
  return (dispatch) => {
    if (!model || (!model.customDate && typeof model.dateDiff !== 'number')) {
      model.dateDiff = moment().diff(moment().subtract(3, 'months'), 'day');
    }
  
    let from, to;
    if (model.customDate) {
      from = moment(model.from).startOf('day');
      to = moment(model.to).endOf('day');
    } else {
      to = moment().endOf('day');
      if (model.fixedStartDate) {
        from = moment(model.from).startOf('day');
      } else {
        from = moment()
          .subtract(model.dateDiff, 'day')
          .startOf('day');
      }
    }    
    dispatch(
      updateDates({
        customDate: model.customDate,
        fixedStartDate: model.fixedStartDate,
        startDate: from,
        endDate: to,
        singleDate: to,
        dateFormat: model.dateFormat,
        daysFromStart: to.diff(from, 'days')
      })
    );
  };
}

export function updateDateRange(dateRange, filtersUpdated) {
  return {
    type: UPDATE_DATE_RANGE,
    name: 'dateRange',
    data: dateRange,
    filtersUpdated
  };
}

export function updateDates(dates, filtersUpdated) {
  return {
    type: UPDATE_DATES,
    name: 'dates',
    data: dates,
    filtersUpdated
  };
}

export function activatePremium(from = '/') {
  return (dispatch) => {
    return BECaller.api(`executive/activate?from=${from}`, 'get')
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        dispatch(handleError(err));
      });
  }
}
